<script setup lang="ts">
const { t } =  useI18n({
  useScope: "local",
});

const { getTrackingConfig } = useTrackingConfig();
const trackingButton = getTrackingConfig('search', 'buttons','shoutOutRegisterNow');
const trackingElement = getTrackingConfig('search', 'elements','shoutOutRegisterNow');
const randomNum = Math.floor(Math.random() * 7);
const headline = t(`headline.enumerations[${randomNum}]`);
const subHeadline = t(`text.enumerations[${randomNum}]`);
const buttonKey = t(`button.enumerations[${randomNum}]`);
</script>

<template>
  <div
    class="tw-tracking shout-out-box primary-alert"
    :data-tracking-id="trackingElement.dataTrackingId[randomNum]"
    data-pagge="search"
    :data-headline="headline"
    :data-subheadline="subHeadline"
    :aria-labelledby="headline"
    :aria-describedby="subHeadline"
  >
    <h2>{{ headline }}</h2>
    <p>{{ subHeadline }}</p>
    <div class="already-account">
    <tw-button-register
      :button-text="buttonKey"
      :data-tracking-id="trackingButton.dataTrackingId[randomNum]"
      data-page="search"
    />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tw-variables.scss';
@import '@/assets/styles/tw-mixins.scss';

.shout-out-box {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-direction: column;
  box-shadow: 0 2px 14px $shout-out-shaddow;
  border-radius: 2px !important;
  padding: .75rem 1.25rem;
  margin: 1.5rem 0;
  h2 {
    text-align: center  ;
    font-size: 1.75rem;
    line-height: 1.75rem;
    @include tw-is-desktop {
      font-size: 2.25rem;
      line-height: 2.75rem;
    }
  }
  h2, p {
    margin: 0;
  }
  .action {
    text-align: center;
  }
  p {
    text-align: center;
    @include tw-is-desktop {
      max-width: 80%;
    }
  }
  .already-account {
    font-size: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    @include tw-is-desktop {
      gap: 0.5rem;
      flex-direction: row;
    }
  }
  svg {
    height: 2rem;
    margin-right: 1rem;
  }
}

.primary-alert {
  @include alert-variant($primary-20, $primary-30, $primary);
}

button {
  color: $white;
  text-transform: uppercase;
  font-weight: bold;
  padding: calc(0.26rem* 2.5) calc(0.26rem* 8);
}
</style>

<i18n lang="json">
{
  "de": {
    "headline": {
      "enumerations": [
        "Keine Massenbesichtigungen! 🚫",
        "Tauschen statt suchen! 🔄",
        "Mehr Platz für deine Familie! 🏠",
        "Tausche direkt und unkompliziert! 🔄",
        "Deine Wunschwohnung wartet! ✨"
       ,"Schnapp dir deine Tauschwohnung!",
        "Dein neues Zuhause wartet!"
      ]
    },
    "text": {
      "enumerations": [
        "Keine Massenbesichtigungen, kein stundenlanges Suchen – bei uns findest du deine Traumwohnung stressfrei und schnell durch Wohnungstausch.",
        "Tauschen statt suchen – spare dir doppelte Mietzahlungen und halbiere deine Umzugskosten.",
        "Vergrößert sich deine Familie? Mit unserem Wohnungstausch findest du das passende Zuhause mit mehr Platz und Spielraum für alle.",
        "Mit Tauschwohnung bestimmst du selbst, wann, wo und wie du deine Traumwohnung findest. Tausche direkt und unkompliziert.",
        "Finde das perfekte Zuhause ohne nervigen Wettbewerb und hohe Mieten – Wohnungstausch eröffnet dir neue Chancen in deiner Wunschgegend.",
        "Finde das perfekte Zuhause ohne nervigen Wettbewerb und hohe Mieten – Wohnungstausch eröffnet dir neue Chancen in deiner Wunschgegend.",
        "Finde das perfekte Zuhause ohne nervigen Wettbewerb und hohe Mieten – Wohnungstausch eröffnet dir neue Chancen in deiner Wunschgegend."
      ]
    },
    "button": {
      "enumerations": [
        "Jetzt registrieren und stressfrei tauschen",
        "Jetzt registrieren und Kosten sparen",
        "Jetzt registrieren und Platz finden",
        "Jetzt kostenlos registrieren",
        "Jetzt kostenfrei registrieren",
        "Jetzt kostenfrei registrieren",
        "Jetzt kostenfrei registrieren"
      ]
    },
    "already_an_account": "Du hast bereits ein Konto? ",
    "login_now": "Jetzt anmelden"
  },
  "en": {
    "headline": {
      "enumerations": [
        "No mass viewings! 🚫",
        "Swap instead of search! 🔄",
        "More space for your family! 🏠",
        "Swap directly and easily! 🔄",
        "Your dream apartment is waiting! ✨",
        "Grab your swap apartment!",
        "Your new home is waiting!"
      ]
    },
    "text": {
      "enumerations": [
        "No mass viewings, no hours of searching – with us you will find your dream apartment stress-free and quickly through apartment exchange.",
        "Swap instead of search – save yourself double rent payments and halve your moving costs.",
        "Is your family growing? With our apartment exchange you will find the right home with more space and room to play for everyone.",
        "With Tauschwohnung you decide when, where and how you find your dream apartment. Swap directly and easily.",
        "Find the perfect home without annoying competition and high rents – apartment exchange opens up new opportunities for you in your desired area.",
        "Find the perfect home without annoying competition and high rents – apartment exchange opens up new opportunities for you in your desired area.",
        "Find the perfect home without annoying competition and high rents – apartment exchange opens up new opportunities for you in your desired area."
      ]
    },
    "button": {
      "enumerations": [
        "Register now and swap stress-free",
        "Register now and save costs",
        "Register now and find space",
        "Register now for free",
        "Register now for free of charge",
        "Register now for free of charge",
        "Register now for free of charge"
      ]
    },
    "already_an_account": "Already have an account? ",
    "login_now": "Log in now"
  }
}
</i18n>
